// Mobile-only navigation enhancement for the public VinCentrix marketing homepage.
// The existing desktop navigation/dropdowns remain untouched.

const MOBILE_QUERY = '(max-width: 768px)';
const STYLE_ID = 'vc-marketing-mobile-nav-styles';
const TOGGLE_ID = 'vc-marketing-mobile-toggle';
const MENU_ID = 'vc-marketing-mobile-menu';

const links = [
  { label: 'Features', href: '#features' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Request Demo', href: '#demo-section' },
  { label: 'About Us', href: '#about' },
  { label: 'Careers', href: '#careers' },
  { label: 'Contact', href: '#demo-section' },
  { label: 'Login', href: '/login', primary: true }
];

const ensureStyles = () => {
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    .vc-marketing-mobile-toggle,
    .vc-marketing-mobile-menu {
      display: none;
    }

    @media (max-width: 768px) {
      body.vc-marketing-home-active {
        overflow-x: hidden !important;
        max-width: 100vw;
      }

      .vc-marketing-home-active .vc-marketing-desktop-nav {
        display: none !important;
      }

      .vc-marketing-home-active .vc-marketing-header-inner {
        width: 100%;
        min-width: 0;
        gap: 12px;
      }

      .vc-marketing-home-active .vc-marketing-header-inner > div:first-child {
        min-width: 0;
        max-width: calc(100vw - 88px);
        overflow: hidden;
      }

      .vc-marketing-home-active .vc-marketing-header-inner .vincentrix-logo {
        min-width: 0;
        max-width: 100%;
      }

      .vc-marketing-mobile-toggle {
        flex: 0 0 46px;
        width: 46px;
        height: 46px;
        padding: 0;
        border: 1px solid rgba(255,255,255,0.16);
        border-radius: 13px;
        background: rgba(255,255,255,0.07);
        color: #fff;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 1003;
        -webkit-tap-highlight-color: transparent;
      }

      .vc-marketing-home-active .vc-marketing-mobile-toggle {
        display: flex;
      }

      .vc-marketing-mobile-toggle span,
      .vc-marketing-mobile-toggle::before,
      .vc-marketing-mobile-toggle::after {
        content: '';
        position: absolute;
        width: 20px;
        height: 2px;
        border-radius: 999px;
        background: currentColor;
        transition: transform 0.2s ease, opacity 0.2s ease;
      }

      .vc-marketing-mobile-toggle::before { transform: translateY(-6px); }
      .vc-marketing-mobile-toggle::after { transform: translateY(6px); }

      .vc-marketing-mobile-toggle[aria-expanded='true'] span { opacity: 0; }
      .vc-marketing-mobile-toggle[aria-expanded='true']::before { transform: rotate(45deg); }
      .vc-marketing-mobile-toggle[aria-expanded='true']::after { transform: rotate(-45deg); }

      .vc-marketing-mobile-menu {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1002;
        background: rgba(3, 6, 14, 0.98);
        backdrop-filter: blur(24px);
        -webkit-backdrop-filter: blur(24px);
        border-top: 1px solid rgba(255,255,255,0.12);
        padding: 18px 16px calc(24px + env(safe-area-inset-bottom));
        overflow-y: auto;
        overflow-x: hidden;
      }

      .vc-marketing-mobile-menu.is-open {
        display: block;
      }

      .vc-marketing-mobile-menu a {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 52px;
        padding: 13px 16px;
        margin: 0 0 6px;
        border-radius: 12px;
        color: rgba(255,255,255,0.9);
        text-decoration: none;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.2px;
        border: 1px solid transparent;
      }

      .vc-marketing-mobile-menu a:active {
        background: rgba(255,255,255,0.08);
      }

      .vc-marketing-mobile-menu a.vc-marketing-login {
        margin-top: 14px;
        justify-content: center;
        color: #fff;
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 55%, #1d4ed8 100%);
        border-color: rgba(96,165,250,0.55);
        box-shadow: 0 8px 28px rgba(37,99,235,0.28);
      }
    }
  `;
  document.head.appendChild(style);
};

const teardown = () => {
  document.body.classList.remove('vc-marketing-home-active');
  document.querySelector('.vc-marketing-header-inner')?.classList.remove('vc-marketing-header-inner');
  document.querySelector('.vc-marketing-desktop-nav')?.classList.remove('vc-marketing-desktop-nav');
  document.getElementById(TOGGLE_ID)?.remove();
  document.getElementById(MENU_ID)?.remove();
};

const setup = () => {
  ensureStyles();

  if (window.location.pathname !== '/' || !window.matchMedia(MOBILE_QUERY).matches) {
    teardown();
    return;
  }

  const header = document.querySelector('header');
  const headerInner = header?.firstElementChild;
  const desktopNav = header?.querySelector('nav');

  if (!header || !headerInner || !desktopNav) return;

  document.body.classList.add('vc-marketing-home-active');
  headerInner.classList.add('vc-marketing-header-inner');
  desktopNav.classList.add('vc-marketing-desktop-nav');

  let menu = document.getElementById(MENU_ID);
  let toggle = document.getElementById(TOGGLE_ID);

  if (!menu) {
    menu = document.createElement('nav');
    menu.id = MENU_ID;
    menu.className = 'vc-marketing-mobile-menu';
    menu.setAttribute('aria-label', 'Mobile marketing navigation');

    links.forEach(({ label, href, primary }) => {
      const anchor = document.createElement('a');
      anchor.href = href;
      anchor.textContent = label;
      if (primary) anchor.className = 'vc-marketing-login';
      anchor.addEventListener('click', () => closeMenu());
      menu.appendChild(anchor);
    });

    document.body.appendChild(menu);
  }

  if (!toggle) {
    toggle = document.createElement('button');
    toggle.id = TOGGLE_ID;
    toggle.className = 'vc-marketing-mobile-toggle';
    toggle.type = 'button';
    toggle.setAttribute('aria-label', 'Open navigation menu');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', MENU_ID);
    toggle.innerHTML = '<span></span>';
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      isOpen ? closeMenu() : openMenu();
    });
    headerInner.appendChild(toggle);
  }

  const headerBottom = Math.ceil(header.getBoundingClientRect().bottom);
  menu.style.top = `${headerBottom}px`;
};

const openMenu = () => {
  const toggle = document.getElementById(TOGGLE_ID);
  const menu = document.getElementById(MENU_ID);
  if (!toggle || !menu) return;
  toggle.setAttribute('aria-expanded', 'true');
  toggle.setAttribute('aria-label', 'Close navigation menu');
  menu.classList.add('is-open');
  document.body.style.overflow = 'hidden';
};

const closeMenu = () => {
  const toggle = document.getElementById(TOGGLE_ID);
  const menu = document.getElementById(MENU_ID);
  if (toggle) {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open navigation menu');
  }
  menu?.classList.remove('is-open');
  document.body.style.overflow = '';
};

if (typeof window !== 'undefined') {
  ensureStyles();

  const observer = new MutationObserver(() => setup());
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('resize', setup);
  window.addEventListener('popstate', () => {
    closeMenu();
    setTimeout(setup, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
}
